import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    question: "Do I need prior coding experience to join the courses?",
    answer: "Not at all! Our courses, including our comprehensive Data Science program, are designed to take you from Beginner to Advanced. We start with the absolute basics before moving on to complex, real-world projects."
  },
  {
    question: "Can I pay for the course in installments?",
    answer: "Yes! We understand that flexibility is important. When you click 'Enroll', you can choose the 'Partial Payment' option to request an installment plan. Our Admin team will quickly review your request and help you get set up."
  },
  {
    question: "Will I receive a certificate upon completion?",
    answer: "Absolutely. Once you complete all the modules and final projects in your chosen course, you will receive a verifiable TrekVerse Certificate of Completion that you can add to your resume and LinkedIn profile."
  },
  {
    question: "How long do I get access to the course materials?",
    answer: "Once you enroll and your payment is finalized, you get lifetime access to the course curriculum. You can revisit the videos, code snippets, and resources whenever you need a refresher."
  },
  {
    question: "Are the classes live or pre-recorded?",
    answer: "Our core curriculum consists of high-quality, pre-recorded video modules. This allows you to learn completely at your own pace, pause when you need to code along, and rewind complex topics."
  },
  {
    question: "What if I get stuck or have doubts while learning?",
    answer: "You are never learning alone. You can always reach out to our support team for technical assistance, and we provide dedicated avenues to get your coursework questions answered."
  },
  {
    question: "Can I access the courses on my mobile phone?",
    answer: "Yes! The TrekVerse platform is fully responsive. You can watch course videos and read materials on your phone or tablet, though we recommend a laptop or desktop for writing code and following along with projects."
  },
  {
    question: "I forgot my password. How do I get back into my account?",
    answer: "It happens to the best of us! Just head to the Login page and click 'Forgot Password?'. Enter your email, and we will instantly send you a secure link to create a brand-new password."
  },
  {
    question: "What are the system requirements for the courses?",
    answer: "Any modern laptop or desktop (Windows, Mac, or Linux) with a stable internet connection will work perfectly. You don't need an expensive supercomputer; all the tools we teach run smoothly on standard machines."
  },
  {
    question: "What is your refund policy?",
    answer: "We want you to be completely satisfied with your learning experience. If you enroll in a course and realize it's not the right fit, we offer a standard 7-day money-back guarantee. Just contact our admin team!"
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    // If clicking the one that is already open, close it. Otherwise, open the new one.
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2>Got Questions?</h2>
          <p>Everything you need to know about learning with TrekVerse.</p>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">
                  {activeIndex === index ? '−' : '+'}
                </span>
              </div>
              <div 
                className="faq-answer-wrapper"
                style={{
                  maxHeight: activeIndex === index ? '200px' : '0',
                  opacity: activeIndex === index ? 1 : 0
                }}
              >
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;